export default __webpack_public_path__ + "static/signup-2a622118b9a0410f671743ea9773e16c.jpg";